import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './store';
import { setUser } from './store/slices/authSlice';
import { authService } from './services/api';
import AppRoutes from './routes';
import { Loading } from './components/common';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { accessToken, isLoading } = useAppSelector(state => state.auth);

  useEffect(() => {
    const initializeAuth = async () => {
      if (accessToken) {
        try {
          const user = await authService.verifyToken(accessToken);
          dispatch(setUser(user));
        } catch {
          // Token is invalid, will be handled by the auth slice
          console.log('Invalid token, user will need to login again');
        }
      }
    };

    initializeAuth();
  }, [accessToken, dispatch]);

  if (isLoading) {
    return <Loading fullScreen text="Initializing..." />;
  }

  return <AppRoutes />;
};

export default App;
